
namespace Matrix.Workflow {

    @Serenity.Decorators.registerClass()
    export class WorkflowGrid extends SiteEntityGrid<WorkflowRow, any> {
        protected getColumnsKey() { return 'Workflow.Workflow'; }
        protected getDialogType() { return WorkflowDialog; }
        protected getIdProperty() { return WorkflowRow.idProperty; }
        protected getLocalTextPrefix() { return WorkflowRow.localTextPrefix; }
        protected getService() { return WorkflowService.baseUrl; }

        constructor(container: JQuery) {
            super(container);
        }
    }
}